<template>
	<SOSlotModal
		:modal-id="pageSetting.modalId"
		:modal-title="pageSetting.modalTitle"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="d-flex align-items-center p-x-20 p-y-8 bg-gray">
				<div class="p-r-12">
					<img src="@/assets/icons/info-grey.svg" alt="">
				</div>
				<div class="f-regular f-12 f-c-midgrey">
					Penolakan setoran ini akan mengubah status menjadi ditolak & <b>mengembalikan pencatatan keuangan
					dari tujuan setoran ke kas laci outlet.</b>
				</div>
			</div>
			<div class="p-x-20 p-y-16">
				<div class="f-regular f-16 f-c-black m-d-16">
					Tolak setoran ini?
				</div>
				<SOInputRegular
					:title="'Alasan'"
					:required="true"
					:placeholder="'Catatan...'"
					:value="''"
					:validation="'alphanumeric'"
					v-model="catatan"
				/>
				<ErrorMessage
					class="error"
					label="Alasan"
					:validation="$v.catatan"
				/>
			</div>
		</template>
		<template v-slot:modal-footer>
			<div class="p-x-20 p-y-16">
				<SOButton
					:text="'Tolak'"
					:outline="true"
					:full="true"
					:loading="pageSetting.btn.accept.loading"
					:disable="pageSetting.btn.accept.disabled"
					@action="tolak"
				/>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import ErrorMessage from "@/component-items/ErrorMessage";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "ModalSetoranKasOutletTolak",
	components: {
		SOSlotModal,
		ErrorMessage,
		SOInputRegular,
		SOButton,
	},
	data() {
		return {
			pageSetting: {
				modalId: "modal-setoran-kas-outlet-setujui",
				modalTitle: "Tolak Setoran",
				btn: {
					accept: {
						loading: false,
						disabled: false
					}
				}
			},
			idtransfer: "",
			catatan: "",
			isNotification: false,
		}
	},
	validations: {
		catatan: {
			required,
		}
	},
	mounted() {
		$("#" + this.pageSetting.modalId).modal("show");
		this.idtransfer = this.$route.params.id
		this.isNotification = this.$route.params.isNotification
	},
	methods: {
		close() {
			$("#" + this.pageSetting.modalId).modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 300)
		},
		errorValidation() {
			this.$v.catatan.$touch()
			return this.$v.catatan.$invalid
		},
		async tolak() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			this.pageSetting.btn.accept.loading = true
			this.pageSetting.btn.accept.disabled = true
			let form = new FormData()
			form.append("idtransfer", this.idtransfer)
			form.append("status", 3)
			form.append("keterangan", this.catatan)
			const res = await this.$store.dispatch("setoranKasOutletModule/confirm", form)
			this.pageSetting.btn.accept.loading = false
			this.pageSetting.btn.accept.disabled = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.$toast.success(res.msg)
			await this.$store.commit("setoranKasOutletModule/resetSetoranKasOutlet")
			if (this.isNotification) {
          this.flutterNavigate("dashboard/notification");
          return;
            }
			await this.$router.go(-2)
		}
	}
}
</script>